import ErrorCircleIcon from './ErrorCircleIcon';

export default ErrorCircleIcon;
